export default __webpack_public_path__ + "static/media/portfolio-199.82b76f2b.jpg";